const ADD_TO_BASKET = 'efes/recurringPayments/ADD_TO_BASKET';
const UPDATE_BASKET = 'efes/recurringPayments/UPDATE_BASKET';
const REMOVE_FROM_BASKET = 'efes/basket/REMOVE_FROM_BASKET';
const BULK_UPDATE_BASKET = 'efes/basket/BULK_UPDATE_BASKET';

const initialState = {
  basket: [],
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case ADD_TO_BASKET:
      return {
        ...state,
        basket: [...state.basket, action.c],
      };

    case UPDATE_BASKET:
      return {
        ...state,
        basket: state.basket.map((c) => (c.policyNumber === action.c.policyNumber ? action.c : c)),
      };

    case REMOVE_FROM_BASKET:
      return {
        ...state,
        basket: state.basket.filter((c) => c.policyNumber !== action.cNum),
      };
    case BULK_UPDATE_BASKET:
      return {
        ...state,
        basket: action.items,
      };

    default:
      return state;
  }
}

export const addToBasket = (c) => ({
  type: ADD_TO_BASKET,
  c,
});

export const updateBasket = (c) => ({
  type: UPDATE_BASKET,
  c,
});

export const removeFromBasket = (cNum) => ({ type: REMOVE_FROM_BASKET, cNum });

export const bulkUpdateBasket = (items) => ({
  type: BULK_UPDATE_BASKET,
  items,
});

export const clearBasket = () => ({
  type: BULK_UPDATE_BASKET,
  items: [],
});
